import styled from 'styled-components';

// Phone-first: someone is standing in a shed holding a phone, so the card is
// centred, narrow, and the primary action is a full-width thumb target.
const TrainingSessionRegisterWrapper = styled.div`
  max-width: 560px;
  margin: 0 auto;
  padding: 8px 0 32px;

  .scan-loading {
    display: flex;
    justify-content: center;
    padding: 64px 0;
  }

  .scan-card {
    border-radius: 12px;

    .ant-card-head-title {
      white-space: normal;
      font-size: 18px;
      font-weight: 600;
      line-height: 1.35;
    }
  }

  .session-facts {
    margin-bottom: 16px;

    .ant-descriptions-item-label {
      width: 110px;
      color: #8c8c8c;
    }
  }

  .assessment-notice {
    margin-bottom: 16px;
    border-radius: 8px;
  }

  .scan-actions {
    margin-top: 8px;

    .ant-btn {
      height: 48px;
      border-radius: 8px;
      font-weight: 600;
    }
  }

  .score-panel {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 28px;
    flex-wrap: wrap;
    margin-top: 8px;
  }

  .score-facts {
    display: flex;
    flex-direction: column;
    gap: 8px;
    text-align: left;

    > div {
      display: flex;
      align-items: center;
      gap: 10px;
    }

    .label {
      color: #8c8c8c;
      min-width: 78px;
    }

    .value {
      font-weight: 600;
    }
  }
`;

export default TrainingSessionRegisterWrapper;
